import { connect } from 'react-redux';
import * as screenActions from '../../redux/actions/screenActions';

export default (WrappedComponent) => connect(null, screenActions)(WrappedComponent);
